import {
  ExportDialogContainer,
  ExportSettingsMetadata,
} from '../../../../shared/components/DocumentExports/ExportDialogContainer';
import { useGetExportSettingsMetadata } from '../hooks/useGetExportSettingsMetadata';

type SequenceExportContainerProps = {
  /**
   * The format of the export. This is used to get the export settings metadata.
   */
  format: string;
  /**
   * The ID of the preset to use for the export. This is used to get the export settings metadata.
   */
  presetId: string;
  /**
   * Whether the entire sequence will be exported. This is used to get the export settings metadata.
   */
  isEntireSequence: boolean;
  children: React.ReactNode;
} & Omit<React.ComponentProps<typeof ExportDialogContainer>, 'metadata'>;

export const SequenceExportContainer = ({
  format,
  presetId,
  isEntireSequence,
  isLoading = false,
  children,
  onCancel,
  onSubmit,
  error,
}: SequenceExportContainerProps) => {
  const { metadata } = useGetExportSettingsMetadata({
    format,
    presetId,
    entireSequence: isEntireSequence,
  });

  return (
    <ExportDialogContainer
      error={error}
      isLoading={isLoading}
      metadata={<ExportSettingsMetadata metadata={metadata} />}
      onCancel={onCancel}
      onSubmit={onSubmit}
    >
      {children}
    </ExportDialogContainer>
  );
};
